module.exports = __webpack_public_path__ + "static/media/TD.60ea4c1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TD.svg
// module id = 370
// module chunks = 0